<template>
  <div class="presentation-empty">
    <div class="notify-text">
      {{ $t('your_future_presentations_shown_here') }}
    </div>
    <button
      class="cta-button"
      @click="handleJoinPresentationClick"
    >
      {{ $t('join_a_presentation') }}
    </button>
  </div>
</template>

<script>
import util from '@/util'

export default {
  methods: {
    handleJoinPresentationClick() {
      this.$router.push({ name: 'home' })
      util.ga4Track('Account > Join a presentation')
    },
  },
}
</script>

<style lang="scss" scoped>
.cta-button {
  -webkit-text-size-adjust: 100%;
  --rem: 16;
  tab-size: 4;
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: currentColor;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  font-family: inherit;
  margin: 0;
  text-transform: none;
  background-image: none;
  cursor: pointer;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  font-weight: 700;
  min-width: 2.5rem;
  --tw-text-opacity: 1;
  color: rgba(245, 245, 245, var(--tw-text-opacity));
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgba(52, 142, 246, var(--tw-bg-opacity));
  --tw-shadow: 0 4px 0px #257ADC;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  height: 2.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  -webkit-appearance: button;
  padding: 8px 20px;

  &:hover:not(:active):not(:disabled) {
    --tw-shadow: 0px 3px 0px #257ADC;
    --tw-translate-y: 0.0625rem;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  &:focus {
    outline: none !important;
  }

  &:active:not(:disabled) {
    --tw-bg-opacity: 1;
    background-color: rgba(37, 122, 220, var(--tw-bg-opacity));
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    --tw-translate-y: 0.25rem;
  }
}

.presentation-empty {
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0px 1px 3px 0px #D3D7E1CF;
  font-size: 0.875rem;

  .notify-text {
    margin-bottom: 16px;
    color: #0A0A0A;
  }
}

@media screen and (min-width: 1280px) {
  .presentation-empty {
    padding: 41px 24px;

    .notify-text {
      line-height: 20px;
    }
  }
}
</style>
